import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { toast } from 'sonner'
import type {
  ApiResponse,
  ApplyProviderTagInput,
  ApplyProviderTagResponse,
  CreateProviderTagInput,
  ProviderTagType,
  UnapplyProviderTagInput,
  UnapplyProviderTagResponse,
  UpdateProviderTagInput,
} from '@magnetar/admin-api-interfaces'

// 後端錯誤回應的資料形狀
interface ApiErrorData {
  error?: {
    code?: string
    message?: string
  }
}

function getApiErrorMessage(error: unknown, fallback: string): string {
  if (axios.isAxiosError<ApiErrorData>(error)) {
    return error.response?.data?.error?.message || fallback
  }
  return fallback
}

export const providerTagService = {
  create: async (data: CreateProviderTagInput, token: string) => {
    try {
      const response = await apiClient.post('/api/provider-tags', data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      toast.success('標籤已建立')
      return response.data
    } catch (error) {
      toast.error(getApiErrorMessage(error, '建立標籤失敗'))
      throw error
    }
  },

  rename: async (id: number, data: UpdateProviderTagInput, token: string) => {
    try {
      const response = await apiClient.patch(`/api/provider-tags/${id}`, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      toast.success('標籤已更新')
      return response.data
    } catch (error) {
      toast.error(getApiErrorMessage(error, '更新標籤失敗'))
      throw error
    }
  },

  delete: async (id: number, token: string) => {
    try {
      const response = await apiClient.delete(`/api/provider-tags/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      toast.success('標籤已刪除')
      return response.data
    } catch (error) {
      toast.error(getApiErrorMessage(error, '刪除標籤失敗'))
      throw error
    }
  },

  apply: async (id: number, data: ApplyProviderTagInput, token: string) => {
    try {
      const response = await apiClient.post<ApiResponse<ApplyProviderTagResponse>>(
        `/api/provider-tags/${id}/apply`,
        data,
        { headers: { Authorization: `Bearer ${token}` } },
      )
      toast.success('標籤已套用')
      return response.data
    } catch (error) {
      toast.error(getApiErrorMessage(error, '套用標籤失敗'))
      throw error
    }
  },

  unapply: async (id: number, data: UnapplyProviderTagInput, token: string) => {
    try {
      const response = await apiClient.post<ApiResponse<UnapplyProviderTagResponse>>(
        `/api/provider-tags/${id}/unapply`,
        data,
        { headers: { Authorization: `Bearer ${token}` } },
      )
      toast.success('已取消套用')
      return response.data
    } catch (error) {
      toast.error(getApiErrorMessage(error, '取消套用失敗'))
      throw error
    }
  },
}

export type { CreateProviderTagInput, UpdateProviderTagInput, ProviderTagType }
